import React from "react";

// ── Score / health colour scale ─────────────────────────────
export const healthColor = (v) =>
  v >= 80 ? "#10b981" : v >= 60 ? "#f59e0b" : "#ef4444";

export const riskColor = (v) =>
  v <= 20 ? "#10b981" : v <= 50 ? "#f59e0b" : "#ef4444";

export const statusColor = (s) => {
  switch (s) {
    case "Active":      return "#10b981";
    case "Idle":        return "#f59e0b";
    case "Maintenance": return "#8b5cf6";
    case "Offline":     return "#ef4444";
    default:            return "#94a3b8";
  }
};

export const statusBg = (s) => {
  switch (s) {
    case "Active":      return "#d1fae5";
    case "Idle":        return "#fef3c7";
    case "Maintenance": return "#ede9fe";
    case "Offline":     return "#fee2e2";
    default:            return "#f1f5f9";
  }
};

export const severityColor = (s) => {
  switch (s) {
    case "Critical": return "#ef4444";
    case "Warning":  return "#f59e0b";
    case "Info":     return "#3b82f6";
    default:         return "#94a3b8";
  }
};

// ── Donut / ring component ───────────────────────────────────
export const HealthRing = ({ value, size = 80, stroke = 8, color }) => {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (value / 100) * circ;
  const col = color || healthColor(value);
  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e2e8f0" strokeWidth={stroke} />
      <circle
        cx={size / 2} cy={size / 2} r={r}
        fill="none" stroke={col} strokeWidth={stroke}
        strokeDasharray={circ} strokeDashoffset={offset}
        strokeLinecap="round"
      />
    </svg>
  );
};

// ── Horizontal bar ───────────────────────────────────────────
export const MiniBar = ({ value, max = 100, color = "#667eea", height = 6 }) => (
  <div style={{ background: "#e2e8f0", borderRadius: 99, height, overflow: "hidden" }}>
    <div style={{ width: `${Math.min((value / max) * 100, 100)}%`, background: color, height: "100%", borderRadius: 99 }} />
  </div>
);

// ── KPI card ────────────────────────────────────────────────
export const KpiCard = ({ label, value, unit, color = "#667eea", icon: Icon, sub }) => (
  <div className="fleet-kpi-card">
    <div className="fleet-kpi-top">
      {Icon && <div className="fleet-kpi-icon" style={{ background: `${color}18`, color }}><Icon size={18} /></div>}
      <span className="fleet-kpi-label">{label}</span>
    </div>
    <div className="fleet-kpi-value" style={{ color }}>
      {value} <span className="fleet-kpi-unit">{unit}</span>
    </div>
    {sub && <div className="fleet-kpi-sub">{sub}</div>}
  </div>
);

// ── Status badge ─────────────────────────────────────────────
export const StatusBadge = ({ status }) => (
  <span className="fleet-status-badge" style={{ background: statusBg(status), color: statusColor(status) }}>
    {status}
  </span>
);

// ── Alert severity badge ─────────────────────────────────────
export const SeverityBadge = ({ severity }) => (
  <span className="fleet-severity-badge" style={{ background: `${severityColor(severity)}18`, color: severityColor(severity) }}>
    {severity}
  </span>
);
